
import { windowatch } from '../../../scripts/lib/windowatch';

const name = 'module-article';
const collapsedAccordionClassName = `${name}__part-accordion--collapsed`;

// sticky spacing in px to the navigation bar
const stickySpacing = 40;

export default class ArticleModule {

  constructor ($el) {

    this.$el = $el;

    // share link state
    this.shareLinkState = 'top';

    // element measurements
    this.headerHeight = null;
    this.innerTop = null;
    this.innerHeight = null;
    this.shareLinkHeight = null;

    // scroll positions
    this.shareLinkStickyScroll = null;
    this.shareLinkBottomScroll = null;

    // bind elements
    this.$header = $el.querySelector(`.${name}__header`);
    this.$inner = $el.querySelector(`.${name}__inner`);
    this.$shareLinks = $el.querySelector(`.${name}__share-links`);

    // collect accordions
    this.$accordions = [...$el.querySelectorAll(`.${name}__part-accordion`)];

    this.accordionToggleEndHandler = new Array(this.$accordions.length);
    this.$accordionOuter = this.$accordions.map($accordion =>
      $accordion.querySelector(`.${name}__accordion-content`));
    this.$accordionInner = this.$accordions.map($accordion =>
      $accordion.querySelector(`.${name}__accordion-parts`));

    // keep collapsed state of accordions
    this.accordionCollapsed = this.$accordions.map($accordion =>
      $accordion.classList.contains(collapsedAccordionClassName));

    // bind events
    this.$accordions.forEach($accordion =>
      $accordion.querySelector(`.${name}__accordion-headline`)
        .addEventListener('click',
          this.accordionWillToggle.bind(this, $accordion)));

    if (this.$shareLinks !== null) {
      windowatch.addResizeListener(this.onResize.bind(this));
      windowatch.addScrollListener(this.onScroll.bind(this),
        ['s', 'm', 'l', 'xl']);
    }
  }

  onResize () {

    if (this.$shareLinks === null) {
      // no layouting necessary when share links are not present
      return;
    }

    const scroll = windowatch.getScrollY();
    const spec = windowatch.getBreakpointSpec();

    // measure element rects
    this.shareLinkHeight = this.$shareLinks.getBoundingClientRect().height;
    this.headerHeight = this.$header.getBoundingClientRect().height;

    const rect = this.$inner.getBoundingClientRect();
    this.innerTop = rect.top + scroll;
    this.innerHeight = rect.height;

    // calculate scroll waypoints
    this.shareLinkStickyScroll =
      this.innerTop
      + this.headerHeight
      - spec.navigationCollapsedHeight
      - stickySpacing;

    this.shareLinkBottomScroll =
      this.innerTop
      + this.innerHeight
      - this.shareLinkHeight
      - spec.navigationCollapsedHeight
      - stickySpacing;

    // update share link top position when in 'top' state
    if (this.shareLinkState === 'top') {
      this.$shareLinks.style.top = `${this.headerHeight}px`;
    }
  }

  onScroll (scroll) {

    // determine the share link state based on new scroll position
    if (scroll < this.shareLinkStickyScroll) {
      this.setShareLinkState('top');
    } else if (scroll < this.shareLinkBottomScroll) {
      this.setShareLinkState('sticky');
    } else {
      this.setShareLinkState('bottom');
    }
  }

  setShareLinkState (shareLinkState) {

    if (this.shareLinkState !== shareLinkState) {
      // when share links are positioned at the top of the article
      // the 'top' style property needs to be maintained
      if (shareLinkState === 'top') {
        this.$shareLinks.style.top = `${this.headerHeight}px`;
      } else if (this.shareLinkState === 'top') {
        this.$shareLinks.removeAttribute('style');
      }

      // update the class name
      this.$shareLinks.className =
        `${name}__share-links ${name}__share-links--${shareLinkState}`;

      // keep track of the current state
      this.shareLinkState = shareLinkState;
    }
  }

  accordionWillToggle ($accordion, evt) {

    evt.preventDefault();

    const index = this.$accordions.indexOf($accordion);
    const $accordionInner = this.$accordionInner[index];
    const $accordionOuter = this.$accordionOuter[index];

    // toggle collapsed state
    this.accordionCollapsed[index] = !this.accordionCollapsed[index];
    const collapsed = this.accordionCollapsed[index];

    // measure content height to transition from / to
    const height = $accordionInner.getBoundingClientRect().height;

    if (collapsed) {
      // prepare collapse transition
      $accordionOuter.style.height = `${height}px`;
      // trigger js cycle
      $accordion.getBoundingClientRect();
    }

    // clear previous transition end handler
    if (this.accordionToggleEndHandler[index]) {
      $accordionOuter.removeEventListener('transitionend',
        this.accordionToggleEndHandler[index]);
    }

    // install transition end handler and keep a reference
    const transitionHandler = () => setTimeout(
      this.accordionDidToggle.bind(this, $accordion, index, collapsed), 100);

    this.accordionToggleEndHandler[index] = transitionHandler;
    $accordionOuter.addEventListener('transitionend', transitionHandler);

    if (collapsed) {
      // trigger collapse transition
      $accordionOuter.removeAttribute('style');
      $accordion.classList.add(collapsedAccordionClassName);

      this.innerHeight -= height;
    } else {
      // trigger expand transition
      $accordion.classList.remove(collapsedAccordionClassName);
      $accordionOuter.style.height = `${height}px`;

      this.innerHeight += height;
    }
  }

  accordionDidToggle ($accordion, index, collapsed, evt) {

    const $accordionOuter = this.$accordionOuter[index];

    if (!collapsed) {
      // remove specified height
      $accordionOuter.removeAttribute('style');
    }

    // trigger resize (module changed its size)
    this.onResize();
  }
}
